import * as React from 'react';
import { Box } from 'signoxe/components/layout';
import { Button } from 'signoxe/components/widgets';
import './styles.scss';

export class DeviceAddSaveCancelWidget extends React.Component<IAddSaveCancelWidgetProps, IAddSaveCancelWidgetState> {
  public static defaultProps = {
    primary: false,
  };

  private textBox?: HTMLInputElement;

  private handleSave = () => {
    if (this.textBox){
      this.props.onToggle(true);
      this.props.onSave(this.textBox.value);
    }
  }
  private handleStopAdding = () => this.props.onToggle(true)
  constructor(props) {
    super(props);
    this.state = {adding: true};
  }

  public render() {
    if (this.state.adding) {
      return (
        <Box direction="row" className="add-save-cancel-widget editing">
          <input type="text" placeholder={this.props.addLabel} ref= {(input: HTMLInputElement) => this.textBox = input} autoFocus/>
          <Button primary className="btn" onClick={this.handleSave}>Save</Button>
          <Button secondary className="btn" onClick={this.handleStopAdding}>Cancel</Button>
        </Box>
      );
    
    }
  }
}

interface IAddSaveCancelWidgetProps {
  addLabel: string;
  onSave: (...args: any[]) => any;
  onToggle: (...args: any[]) => any;
  primary?: boolean;
}

interface IAddSaveCancelWidgetState {
  adding: boolean;
}

export default DeviceAddSaveCancelWidget;



// WEBPACK FOOTER //
// ./src/components/widgets/DeviceAddSaveCancelWidget/index.tsx